var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_45)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.53831 40.5283L40.555 1.51156",
    stroke: "#22574D",
    strokeWidth: 1.84403
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6902 40.8321L40.6902 1.18544",
    stroke: "#22574D",
    strokeWidth: 1.84403
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.582474 1.54375H40.2291",
    stroke: "#22574D",
    strokeWidth: 1.84403
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.5687,
    height: 40.5687,
    fill: "white",
    transform: "translate(0.582489 0.215652)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.5687,
    height: 41.4907,
    fill: "white",
    transform: "translate(0.582489 0.215652)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.7b3ba36ccb8a3b9506cde74d6998afea.svg";
export { ForwardRef as ReactComponent };